import { useContext } from 'react'
import type { InputHTMLAttributes } from 'react'

import { Container, InputContext } from './InputContext'

type InputAttributes = InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>

interface InputProps extends InputAttributes {
  $shape?: 'box' | 'line'
  block?: boolean
  multiline?: boolean
  icon?: any
}

// TODO: block="true" error
function Inner({ value, defaultValue, placeholder, disabled, onChange, ...props }: InputProps) {
  const { handleBlur, handleFocus, handleKeyDown } = useContext(InputContext)

  return (
    <input
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      {...props}
    />
  )
}

export function Input(props: InputProps) {
  const { block, ...innerProps } = props
  return (
    <Container block={block} {...props}>
      <Inner {...innerProps} />
      {props?.icon ?? <></>}
    </Container>
  )
}

export type { InputProps }
